<template>
  <div class="container-fluid" style="padding:0;">
    <tab></tab>
    <div class="row">
      <div class="activity-top" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <img :src="pageInfo.picStr" alt="#" class="inner-item-img"/>
        <div class="activity-top-font">
          <div class="top-font-font">{{lanType==1?'活动':'Events'}}</div>
        </div>
      </div>

      <div class="phone-activity-top hidden-md hidden-lg" v-if="isShowWeb">
        <img :src="pageInfo.picStr" alt="#" class="phone-inner-img"/>
        <div class="activity-top-font">
          <div class="phone-font-font">{{lanType==1?'活动':'Events'}}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="activity-detail hidden-xs hidden-sm" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="activity-detail-title">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        <div class="activity-detail-center spaceBetween">
          <div class="detail-center-left">
            <!-- <div class="center-left-font" v-if="pageInfo.brief">{{lanType==1?pageInfo.brief:pageInfo.briefEn}}</div> -->
            <div class="center-left-font" v-html="lanType==1?pageInfo.brief:pageInfo.briefEn"></div>
            <!-- <div class="center-left-font">活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍。</div>
            <div class="center-left-font mb1">主讲人: </div>
            <div class="center-left-font mb1">某某某 —— 介绍介绍介绍介绍介绍介绍介绍</div>
            <div class="center-left-font mb1">某某某 —— 介绍介绍介绍介绍介绍介绍介绍</div>
            <div class="center-left-font mb1">某某某 —— 介绍介绍介绍介绍介绍介绍介绍</div> -->
            <div class="center-left-btn" @click="submitBtn" v-if="pageInfo.type==1">{{lanType==1?'报名参加':'enter for'}}</div>
          </div>

          <div class="detail-center-right">
            <div class="center-right-list start">
              <div class="right-list-left">{{lanType==1?'开始日期':'Start date'}}：</div>
              <div class="right-list-right">{{pageInfo.start_dateTime}}</div>
            </div>

            <div class="center-right-list start">
              <div class="right-list-left">{{lanType==1?'结束日期':'End date'}}：</div>
              <div class="right-list-right">{{pageInfo.end_dateTime}}</div>
            </div>

            <div class="center-right-list start">
              <div class="right-list-left">{{lanType==1?'活动时间':'Activity time'}}：</div>
              <div class="right-list-right">{{pageInfo.start_time}} {{pageInfo.start_time && pageInfo.end_time ? '-' : ''}} {{pageInfo.end_time}}  {{lanType==1?'北京时间':'episode titled'}}</div>
            </div>

            <div class="center-right-list start">
              <div class="right-list-left">{{lanType==1?'活动地点':'Activity location'}}：</div>
              <div class="right-list-right" v-if="pageInfo.address">{{lanType==1?pageInfo.address:pageInfo.addressEn}}</div>
              <div class="right-list-right" v-else>{{lanType==1?'线上会议':'Online conference'}}</div>
            </div>

            <div class="center-right-list start">
              <div class="right-list-left">{{lanType==1?'活动状态':'Active state'}}：</div>
              <div class="right-list-right" v-if="pageInfo.state==1">{{lanType==1?'即将开始':'begin in a minute'}}</div>
              <div class="right-list-right" v-else>{{lanType==1?'圆满结束':'A successful conclusion'}}</div>
            </div>

            <div class="center-right-list start">
              <div class="right-list-left">{{lanType==1?'活动类别':'Activity category'}}：</div>
              <div class="right-list-right color1" v-if="pageInfo.type==1">SBTi</div>
              <div class="right-list-right color1" v-if="pageInfo.type==2">China Corporate RE 绿色电力</div>
              <div class="right-list-right color1" v-if="pageInfo.type==3">{{lanType==1?'气候创行者':'Climate Solver'}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="phone-activity-detail hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-activity-detail-title">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        <!-- <div class="phone-center-left-font" v-if="pageInfo.brief">{{lanType==1?pageInfo.brief:pageInfo.briefEn}}</div> -->
        <div class="phone-center-left-font" v-html="lanType==1?pageInfo.brief:pageInfo.briefEn"></div>
        <!-- <div class="phone-center-left-font mb2">主讲人: </div>
        <div class="phone-center-left-font mb2">某某某 —— 介绍介绍介绍介绍介绍介绍介绍</div>
        <div class="phone-center-left-font mb2">某某某 —— 介绍介绍介绍介绍介绍介绍介绍</div>
        <div class="phone-center-left-font mb3">某某某 —— 介绍介绍介绍介绍介绍介绍介绍</div> -->

        <div class="phone-detail-center-right">
          <div class="phone-center-right-list start">
            <div class="phone-right-list-left">{{lanType==1?'开始日期':'Start date'}}：</div>
            <div class="phone-right-list-right">{{pageInfo.start_dateTime}}</div>
          </div>

          <div class="phone-center-right-list start">
            <div class="phone-right-list-left">{{lanType==1?'结束日期':'End date'}}：</div>
            <div class="phone-right-list-right">{{pageInfo.end_dateTime}}</div>
          </div>

          <div class="phone-center-right-list start">
            <div class="phone-right-list-left">{{lanType==1?'活动时间':'Activity time'}}：</div>
            <div class="phone-right-list-right">{{pageInfo.start_time}} {{pageInfo.start_time && pageInfo.end_time ? '-' : ''}} {{pageInfo.end_time}}  {{lanType==1?'北京时间':'episode titled'}}</div>
          </div>

          <div class="phone-center-right-list start">
            <div class="phone-right-list-left">{{lanType==1?'活动地点':'Activity location'}}：</div>
            <div class="phone-right-list-right" v-if="pageInfo.address">{{lanType==1?pageInfo.address:pageInfo.addressEn}}</div>
            <div class="phone-right-list-right" v-else>{{lanType==1?'线上会议':'Online conference'}}</div>
          </div>

          <div class="phone-center-right-list start">
            <div class="phone-right-list-left">{{lanType==1?'活动状态':'Active state'}}：</div>
            <div class="phone-right-list-right" v-if="pageInfo.state==1">{{lanType==1?'即将开始':'begin in a minute'}}</div>
            <div class="phone-right-list-right" v-else>{{lanType==1?'圆满结束':'A successful conclusion'}}</div>
          </div>

          <div class="phone-center-right-list start">
            <div class="phone-right-list-left">{{lanType==1?'活动类别':'Activity category'}}：</div>
            <div class="phone-right-list-right color1" v-if="pageInfo.type==1">SBTi</div>
            <div class="phone-right-list-right color1" v-if="pageInfo.type==2">China Corporate RE 绿色电力</div>
            <div class="phone-right-list-right color1" v-if="pageInfo.type==3">{{lanType==1?'气候创行者':'Climate Solver'}}</div>
          </div>
        </div>
        <div class="phone-center-left-btn" @click="submitBtn">{{lanType==1?'报名参加':'enter for'}}</div>
      </div>
    </div>

    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab'
import footerBar from '@/components/footerBar'
import axios from 'axios'
import { chunkArr,format } from '@/utils/util'
import config from '@/utils/config';
import activity from '@/images/activity.png'
export default {
  name: 'wprk',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      pageInfo:{},
      isLogin:false,
      token:'',
      isShowWeb:config.urlList.isShowWeb,
      activity:activity,
      lanType:1
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    queryNewsDetail(){
      const vm=this;
      axios.get(
      `${config.urlList.queryUrl}/api/cbh/campaign_detail/${vm.$route.query.id}`,
      ).then(res => {
        if(res.data.code==1){
          res.data.data.picStr=res.data.data.pic?`${config.urlList.imgUrl}${res.data.data.pic}`:activity;
          
          res.data.data.start_dateTime=format(new Date(res.data.data.start_date),'YYYY年MM月DD日')
          res.data.data.end_dateTime=format(new Date(res.data.data.end_date),'YYYY年MM月DD日')

          res.data.data.titleEn=res.data.data.titleEn?res.data.data.titleEn:res.data.data.title
          res.data.data.briefEn=res.data.data.briefEn?res.data.data.briefEn:res.data.data.brief
          res.data.data.contentEn = res.data.data.contentEn ? res.data.data.contentEn : res.data.data.content
          res.data.data.addressEn = res.data.data.addressEn ? res.data.data.addressEn : res.data.data.address

          res.data.data.content = res.data.data.content ? res.data.data.content.replace(/(width|height)="\d*"\s*/g, '') : ''
          res.data.data.contentEn = res.data.data.contentEn ? res.data.data.contentEn.replace(/(width|height)="\d*"\s*/g, '') : ''

          vm.pageInfo = res.data.data;
        }
      })
    },
    queryUserinfo(){
      const vm=this;
      vm.token = localStorage.getItem('Cbhtoken');
      if(vm.token){
        vm.isLogin=true
      }
      // axios.post(
      // `${config.urlList.queryUrl}/api/cbh/userinfo?token=${token}`,
      // ).then(res => {
      //   if(res.data.code==1){
      //     vm.isLogin=true
      //   }
      // })
    },
    submitBtn(){
      const vm=this
      if(!vm.isLogin){
        vm.$toast({
          text: '您还未登录，请登录后再试！',
          type: 'wraning',
          duration: 1600
        })
        return
      };
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/sign`,
        {
          campaign_id:vm.$route.query.id,
          token:vm.token
        }
      ).then(res => {
        if(res.data.code==1){
          vm.$toast({
            text: '稍后我们会通过邮件与您联系，请注意查收！',
            type: 'wraning',
            duration: 1600
          })
        }else{
          vm.$toast({
            text: res.data.message,
            type: 'error',
            duration: 1600
          })
          console.log('res.data')
          console.log(res.data)
        }
      })
    }
  },
  created () {
    const vm = this;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted(){
    const vm=this
    vm.queryNewsDetail()
    vm.queryUserinfo()
  }
}
</script>
<style scoped>
/**  pc banner图  **/
.activity-top{
  width: 100%;
  height: 2.20625rem;
  position: relative;
}
.inner-item-img{
  width: 100%;
  height: 100%;
}
.activity-top-font{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.top-font-font{
  font-size: 0.375rem;
  color: #fff;
}
/**  web Banner图  **/
.phone-activity-top{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 100%;
}
.phone-font-font{
  font-size: 0.8rem;
  color: #fff;
}

/**  pc  **/
.activity-detail{
  padding: 0.35rem 0.5rem;
  height: auto;
}
.activity-detail-title{
  font-size: 0.225rem;
  color: #000;
  text-align: center;
  line-height: 1.6;
  font-family: 'wwf';
}
.activity-detail-center{
  padding: 0.225rem 0;
  height: auto;
  align-items: flex-start;
}
.detail-center-left{
  flex: 2;
  height: auto;
  padding-right: 0.375rem;
}
.center-left-font{
  font-size: 0.1125rem;
  line-height: 1.6;
  margin-bottom: 0.2rem;
  text-align: left;
}
.mb1{
  margin-bottom: 0.06rem;
}
.center-left-btn{
  width: 1.1875rem;
  height: 0.325rem;
  line-height: 0.325rem;
  font-size: 0.15rem;
  color: #fff;
  text-align: center;
  background: #49bc9b;
  margin-top: 0.2375rem;
  cursor: pointer;
}
.detail-center-right{
  padding-left: 0.375rem;
  border-left: 1px solid #ddd;
}
.center-right-list{
  margin-bottom: 0.25rem;
}
.right-list-left{
  font-size: 0.1125rem;
  color: #000;
  font-weight: 500;
  line-height: 1.6;
}
.right-list-right{
  font-size: 0.1125rem;
  color: #000;
  line-height: 1.6;
}

/**  web  **/
.phone-activity-detail{
  padding: 0.5rem;
}
.phone-activity-detail-title{
  font-size: 0.48rem;
  color: #000;
  text-align: center;
  line-height: 1.6;
  font-family: 'wwf';
}
.phone-center-left-font{
  font-size: 0.32rem;
  line-height: 1.6;
  margin-bottom: 0.4rem;
  text-align: left;
}
.mb2{
  margin-bottom: 0.2rem;
}
.phone-detail-center-right{
  padding-top: 0.5rem;
  height: auto;
}
.phone-center-right-list{
  margin-bottom: 0.5rem;
}
.phone-right-list-left{
  font-size: 0.32rem;
  color: #000;
  font-weight: 500;
  line-height: 1.6;
}
.phone-right-list-right{
  font-size: 0.32rem;
  color: #000;
  line-height: 1.6;
}
.phone-center-left-btn{
  width: 2.667rem;
  height: .8rem;
  background: #49bc9b;
  font-size: .32rem;
  color: #fff;
  font-weight: 500;
  text-align: center;
  line-height: 0.8rem;
  margin: 0.5rem auto;
}
.color1{
  color: #32a5cf;
}
</style>

